// extracted by mini-css-extract-plugin
export default {"form":"StandSettings_form__dDFIL"};